import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
export function usePaymentStats(oppositionId) {
    return useQuery({
        queryKey: ['payment-stats', oppositionId],
        queryFn: () => apiClient(`/payments/stats${oppositionId ? `?opposition_id=${oppositionId}` : ''}`),
        staleTime: 1000 * 60 * 3,
    });
}
//# sourceMappingURL=usePaymentStats.js.map